/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The AccountTitle model module.
 * @module model/AccountTitle
 * @version 1.0.0
 */
export default class AccountTitle {
  /**
   * Constructs a new <code>AccountTitle</code>.
   * @alias module:model/AccountTitle
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>AccountTitle</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AccountTitle} obj Optional instance to populate.
   * @return {module:model/AccountTitle} The populated <code>AccountTitle</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AccountTitle()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('account_title_group_id')) {
        obj['account_title_group_id'] = ApiClient.convertToType(data['account_title_group_id'], 'Number')
      }
      if (data.hasOwnProperty('account_title_group_name')) {
        obj['account_title_group_name'] = ApiClient.convertToType(data['account_title_group_name'], 'String')
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {Number} account_title_group_id
   */
  account_title_group_id = undefined
  /**
   * @member {String} account_title_group_name
   */
  account_title_group_name = undefined
  /**
   * @member {String} name
   */
  name = undefined
}
